import React from "react";
import BoningOrderView from "./BoningOrderView";
import useBoningOrder from "./useBoningOrder";

function BoningOrder() {
  return <BoningOrderView {...useBoningOrder()} />;
}

export default BoningOrder;
